/**
 * Universal Links (iOS) / App Links (Android) handler.
 * When a https://apnapremierleague.com/... URL is tapped from email / WhatsApp / SMS
 * and the app is installed, the OS opens the app with an appUrlOpen event. We parse the
 * pathname and route in-app with React Router so the user lands on the right screen.
 */

// Path prefixes we handle in-app. Anything else falls back to "/".
const HANDLED_PREFIXES = [
  "/football/",
  "/cricket/",
  "/match-day/",
  "/leaderboard",
  "/leagues",
  "/subscribe",
  "/predictor",
  "/profile",
];

function resolvePath(rawUrl) {
  try {
    const u = new URL(rawUrl);
    const path = `${u.pathname}${u.search}` || "/";
    const matched = HANDLED_PREFIXES.some(
      (p) => u.pathname === p || u.pathname.startsWith(p)
    );
    return matched ? path : "/";
  } catch {
    return "/";
  }
}

/**
 * @param {(path: string) => void} navigate - React Router navigate function.
 * @returns {Promise<() => void>} cleanup function to remove the listener.
 */
export async function setupDeepLinkHandler(navigate) {
  try {
    const { Capacitor } = await import("@capacitor/core");
    if (!Capacitor.isNativePlatform()) return () => {};

    const { App } = await import("@capacitor/app");
    const handle = await App.addListener("appUrlOpen", (event) => {
      const path = resolvePath(event?.url || "");
      if (path) navigate(path);
    });
    return () => handle?.remove();
  } catch {
    return () => {};
  }
}

export { resolvePath };
